import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'app-modal-planning-hq-settings',
  templateUrl: './modal-planning-hq-settings.component.html',
  styles: []
})
export class ModalPlanningHqSettingsComponent extends ExcTranslation implements OnInit {

  currentConfig: any[];
  availableCols: any[] = [];
  spanSum = 0;
  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef, private excDss: DefaultSettingsService) {
    super();
    this.currentConfig = [];
    for (let i = 0; i < 12; i++) {
      if (this.excDss.UserSettings['PHQColumns'].length > i) {
        this.currentConfig.push({});
        Object.assign(this.currentConfig[i], this.excDss.UserSettings['PHQColumns'][i]);
        // this.currentConfig.push(this.excDss.UserSettings['PHQColumns'][i]);
      } else {
        this.currentConfig.push({col: null, span: null});
      }
    }
    this.getAvailableCols();
  }
  reset() {
    this.excDss.LoadDefault();
    this.currentConfig = [];
    for (let i = 0; i < 12; i++) {
      if (this.excDss.UserSettings['PHQColumns'].length > i) {
        this.currentConfig.push({});
        Object.assign(this.currentConfig[i], this.excDss.UserSettings['PHQColumns'][i]);
        // this.currentConfig.push(this.excDss.UserSettings['PHQColumns'][i]);
      } else {
        this.currentConfig.push({col: null, span: null});
      }
    }
    this.getAvailableCols();
  }
  recomputeCols() {
    for (const x of this.availableCols) {
      let found = false;
      for (const a of this.currentConfig) {
        if (a.col === x.value) {
          found = true;
          break;
        }
      }
      x.disabled = found;
    }
  }
  swapUp(idx) {
    const tmp = {};
    Object.assign(tmp, this.currentConfig[idx]);
    Object.assign(this.currentConfig[idx], this.currentConfig[idx - 1]);
    Object.assign(this.currentConfig[idx - 1], tmp);
  }
  swapDown(idx) {
    const tmp = {};
    Object.assign(tmp, this.currentConfig[idx]);
    Object.assign(this.currentConfig[idx], this.currentConfig[idx + 1]);
    Object.assign(this.currentConfig[idx + 1], tmp);
  }
  remove(idx) {
    this.currentConfig.splice(idx,1);
    this.currentConfig.push({col: null, span: null});
  }
  getAvailableCols() {
    this.availableCols = [];
    this.availableCols.push({text: this.getRessource('Col_null'), value: null});
    for (const a of Object.keys(this.overlayConfig.data.def)) {
      let found = false;
      for (const b of this.currentConfig) {
        if (b.col === a) {
          found = true;
          break;
        }
      }
      // if (!found) {
        this.availableCols.push({text: this.getColName({col: a}), value: a, disabled: found});
      // }
    }
  }

  proceed() {
    const sn = [];
    this.overlayRef.close({proceed: true, settingsNew: this.currentConfig});
  }
  countSpans() {
    let x = 0;
    for (const c of this.currentConfig) {
      if (c.col !== null) {
        x += c.span;
      }
    }
    return x;
  }
  getColName(obj) {
    if (this.excDss.MandantSettings['Labels'][obj.col] === undefined) {
      return this.getRessource('Col_' + obj.col);
    }
    return this.excDss.MandantSettings['Labels'][obj.col];
  }
  setCol(e, idx) {
    this.currentConfig[idx].col = e;
    if (this.currentConfig[idx].span === null) {
      this.currentConfig[idx].span = this.overlayConfig.data.def[this.currentConfig[idx].col]['spanMin'];
    }
    this.recomputeCols();
  }
  setSpan(e, idx) {
    this.currentConfig[idx].span = e;
    this.spanSum = this.countSpans();
  }
  getSpans(idx) {
    if (this.currentConfig[idx]['col'] === null) {
      return [];
    }
    const min = this.overlayConfig.data.def[this.currentConfig[idx].col]['spanMin'];
    const max = this.overlayConfig.data.def[this.currentConfig[idx].col]['spanMax'];

    const sp = [];
    for (let x = min; x <= max; x++) {
        sp.push({value: x, text: x, selected: this.currentConfig[idx]['span'] === x});
    }
    return sp;
  }
  getFreeCols(idx) {
    const x = [];
    x.push({text: this.getRessource('Col_null'), value: '', selected: this.currentConfig[idx].col === null});
    for (const a of Object.keys(this.overlayConfig.data.def)) {
      x.push({text: this.getColName({col: a}), value: a, selected: this.currentConfig[idx].col === a});
    }
    return x;
  }
  ngOnInit() {

  }


}
